import { Box, Image, Flex } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import slipball_dot from "../utills/images/slipballdot.png"
import slipballbg from "../utills/images/slipballbg.png"

function Heading({ onScoreChange }) {
    const [slipoffset, setSlipoffset] = useState(0);
    const [score, setScore] = useState(0);
    const [tq, setTq] = useState(0);

    useEffect(() => {
        let interval = setInterval(() => {
            const randomSlipOffset = Math.random() < 0.5 ? -10 : 10;
            setSlipoffset((prevSlipOffset) => prevSlipOffset - randomSlipOffset);
        }, 2000);

        return () => {
            clearInterval(interval);
        };
    }, []);

    const handleKeyPress = (event) => {
        if (event.key === "a") {
            setSlipoffset((prevSlipOffset) => prevSlipOffset + 10);
        } else if (event.key === "s") {
            setSlipoffset((prevSlipOffset) => prevSlipOffset - 10);
        }
    };

    useEffect(() => {
        if (slipoffset === 0) {
            setScore((pre) => pre + 1);
            setSlipoffset(0);
        }
        setTq((prev) => prev + 1);
    }, [slipoffset]);

    useEffect(() => {
        document.addEventListener("keydown", handleKeyPress);

        return () => {
            document.removeEventListener("keydown", handleKeyPress);
        };
    }, []);

    useEffect(() => {
        let temp = Math.floor((score / tq) * 100);
        onScoreChange(temp, "headingScore");
    }, [score])

    return (
        <Box display={"grid"} gridAutoRows={"2,1fr"} gap={"10px"}>
            <Box className="slipballscroll" bgImage={slipballbg} width={"300px"} bgSize={"300px"}>
                <Box
                    position="relative"
                    height="90%"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Image
                        src={slipball_dot}
                        height={"100%"}
                        alt="slipballdot"
                        style={{
                            transform: `translateX(${Math.min(Math.max(slipoffset, -150), 150)}px)`,
                            transition: "transform 0.3s",
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
}

export default Heading;
